(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["emotion-flex-grid"] = factory();
	else
		root["emotion-flex-grid"] = factory();
})(this, function() {
return 